<template>
  <div>
    <SmoothReflow
      tag="div"
      :options="{
        property: 'height',
        transition: 'height 300ms cubic-bezier(0.77, 0, 0.175, 1)',
      }"
    >
      <p
        v-if="bidPlaceErrorMessage"
        class="flex flex-col items-center font-medium text-danger leading-tight mb-15"
      >
        <IconFA
          :icon="['fad', 'exclamation-triangle']"
          class="text-3xl mb-5"
        />
        {{ bidPlaceErrorMessage }}
      </p>
    </SmoothReflow>
    <div
      v-if="vehicleStatus === 1"
      class="grid gap-10 tablet:grid-cols-2"
    >
      <button
        v-if="userDetails && userDetails.allowBidDeletion && bidAmount !== ''"
        class="button button-secondary-on-white button-filled button-lg w-full"
        @click="deleteBid"
      >
        {{ $t('vehicle_details.remove_your_bid_text') }}
      </button>
      <button
        class="button button-primary-on-white button-filled button-lg w-full"
        @click="updateBid"
      >
        {{ bidButton }}
      </button>
    </div>
    <div
      v-else
      class="text-center mb-30"
    >
      <p class="font-bold text-xl text-primary mb-10">{{ $t('vehicle_expired.expired_text') }}</p>
      <p
        v-if="bidAmount"
        class="font-bold mb-10"
      >
        {{ $t('vehicle_expired.your_last_offer_was') }}:
        CHF {{ bidAmount ? currencyFormat(bidAmount) : 0 }}
      </p>
      <p class="mb-20">{{ $t('vehicle_expired.wait_another_offer_or_visit_link') }}</p>
      <a
        href="https://autodrop.app"
        class="button-inline button-filled button-primary-on-white button-lg"
      >
        www.autodrop.app
      </a>
    </div>
  </div>
</template>


<script>
import { APIPlaceBid } from '@/api';
import { getVehicleBid } from '@/helpers/firebase/firestoreRefs';
import SmoothReflow from '@/components/SmoothReflow';


export default {
  props: {
    sellerPublicProfile: {
      type: Object,
      default() {
        return {};
      },
    },
    userId: {
      type: String,
      default: '',
    },
    buyerId: {
      type: String,
      default: '',
    },
    userType: {
      type: String,
      default: 'seller',
    },
    vehicleId: {
      type: String,
      default: '',
    },
    vehicleStatus: {
      type: Number,
      default: -1,
    },
  },
  components: {
    SmoothReflow,
  },
  data: () => ({
    bidAmount: '',
    bidPlaceErrorMessage: '',
    unsubVehicleBid: null,
  }),
  created() {
    this.unsubVehicleBid = getVehicleBid(this.vehicleId, this.userId || this.buyerId)
      .onSnapshot((querySnapshot) => {
        if (querySnapshot.exists) this.bidAmount = querySnapshot.data().amount;
        else this.bidAmount = '';
      });
  },
  computed: {
    userDetails() {
     return this.sellerPublicProfile;
    },
    bidButton() {
      if (this.bidAmount === '') return this.$t('vehicle_details.place_your_bid_text');
      if (this.bidAmount !== '' && this.userDetails?.allowBidModification) {
        return `${this.$t('vehicle_details.modify_your_bid_text')} (CHF ${this.currencyFormat(this.bidAmount)})`;
      }

      return `${this.$t('vehicle_details.your_bid_is_text')}: CHF ${this.currencyFormat(this.bidAmount)}`;
    },
  },
  methods: {
    currencyFormat(value) {
      return Number(value).toLocaleString('de-CH');
    },
    updateBid() {
      if (this.userDetails?.allowBidModification || this.bidAmount === '' || this.userType === 'buyer') {
        // eslint-disable-next-line no-alert
        const price = prompt(
          `${this.$t('vehicle_details.enter_your_bid_text')}: CHF ${this.currencyFormat(this.bidAmount)}`,
        );

        if (Number.isNaN(price) || Math.sign(price) !== 1) return;

        if (price <= this.bidAmount) {
          // eslint-disable-next-line no-alert
          alert(this.$t('vehicle_details.bid_is_too_low_text'));
          return;
        }

        // eslint-disable-next-line no-restricted-globals,no-alert
        if (confirm(`${this.$t('vehicle_details.your_bid_is_text')} CHF ${this.currencyFormat(price)}. ${this.$t('vehicle_details.confirm_bid_text')}`)) {
          APIPlaceBid({
            amount: Number.parseInt(price, 10),
            buyerId: this.$route.params.userId || this.buyerId,
            vehicleId: this.vehicleId,
            languageCode: this.$i18n.locale,
          })
            .then(() => {
              this.bidAmount = price;
              this.bidPlaceErrorMessage = '';
            })
            .catch((error) => {
              this.bidAmount = '';
              this.bidPlaceErrorMessage = error?.response?.data?.message || error;
              console.error(error);
            });
        }
      }
    },
    deleteBid() {
      // eslint-disable-next-line no-restricted-globals,no-alert
      if (confirm('Möchten Sie Ihr Gebot stornieren?')) {
        getVehicleBid(this.vehicleId, this.userId || this.buyerId)
          .delete()
          .catch((error) => {
            console.error(error);
          });
        this.bidAmount = '';
      }
    },
  },
  beforeDestroy() {
    if (typeof this.unsubVehicleBid === 'function') this.unsubVehicleBid();
  },
};
</script>
